import { Head } from '@inertiajs/react'
import DashboardLayout from '@/frontend/layouts/DashboardLayout'
import { Section } from '@/components/design-system'
import { AvatarGenerator } from '@/frontend/components/avatar-generator'

interface Props {
  page_title: string
}

export default function AvatarGeneratorIndex({ page_title }: Props) {
  return (
    <>
      <Head title={page_title} />
      <Section
        title="Gerador de Avatar"
        description="Selecione as características do seu coworker digital e gere um avatar em pixel art com IA."
      >
        <AvatarGenerator />
      </Section>
    </>
  )
}

AvatarGeneratorIndex.layout = (page: React.ReactElement) => (
  <DashboardLayout>{page}</DashboardLayout>
)
